import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in name, email and message");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent! We'll be in touch shortly.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Could not send. Please try WhatsApp directly.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full px-4 py-3 border border-stone-300 bg-white focus:border-brand-navyDark focus:ring-0 outline-none transition-colors text-brand-navyDark placeholder:text-stone-400 text-[14px]";
  const labelCls =
    "text-[11px] uppercase tracking-[0.18em] font-medium text-brand-navyDark mb-2 block";

  return (
    <form
      onSubmit={submit}
      className="bg-white p-9 md:p-11 border border-stone-200"
      data-testid="contact-form"
    >
      <div className="mb-9 pb-7 border-b border-stone-200">
        <div className="eyebrow mb-3">Send a Message</div>
        <div className="heading-serif text-3xl font-medium text-brand-navyDark leading-tight">
          We'd love to hear from you
        </div>
        <p className="text-[13px] text-brand-muted mt-2">
          For appointments, second opinions or general queries.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className={labelCls}>Full Name *</label>
          <input
            type="text"
            value={form.name}
            onChange={update("name")}
            className={inputCls}
            placeholder="Your name"
            required
            data-testid="contact-name"
          />
        </div>
        <div>
          <label className={labelCls}>Email *</label>
          <input
            type="email"
            value={form.email}
            onChange={update("email")}
            className={inputCls}
            placeholder="you@example.com"
            required
            data-testid="contact-email"
          />
        </div>
        <div>
          <label className={labelCls}>Phone</label>
          <input
            type="tel"
            value={form.phone}
            onChange={update("phone")}
            className={inputCls}
            placeholder="+91 ..."
            data-testid="contact-phone"
          />
        </div>
        <div>
          <label className={labelCls}>Subject</label>
          <input
            type="text"
            value={form.subject}
            onChange={update("subject")}
            className={inputCls}
            placeholder="How can we help?"
            data-testid="contact-subject"
          />
        </div>
        <div className="md:col-span-2">
          <label className={labelCls}>Message *</label>
          <textarea
            value={form.message}
            onChange={update("message")}
            className={`${inputCls} min-h-[140px]`}
            placeholder="Write your message..."
            required
            data-testid="contact-message"
          />
        </div>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="btn-primary w-full mt-7 disabled:opacity-70"
        data-testid="contact-submit"
      >
        {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Send className="w-3.5 h-3.5" />}
        {loading ? "Sending..." : "Send Message"}
      </button>
    </form>
  );
};
